import { render } from "./SettingsSidebar.vue?vue&type=template&id=84e39a1e"
import script from "./SettingsSidebar.vue?vue&type=script&lang=js"
export * from "./SettingsSidebar.vue?vue&type=script&lang=js"
script.render = render

export default script